import React from "react";
import {Button} from "react-bootstrap";
import {connect} from "react-redux";

class EditBookLMetaData extends React.Component{
    constructor(props) {
      super(props);
    
      this.state = {
        data:{
            booklist_title: this.props.booklists.booklist_title,
            booklist_description: this.props.booklists.booklist_description
        },
        old_booklist_title: this.props.booklists.booklist_title,
        old_booklist_description: this.props.booklists.booklist_description
      };
    };
    onsubmit=e=>{
        e.preventDefault();
    };
    deleteBook = e => {
        this.setState({loading: true});
        var arr = this.props.AllbookLists;
        arr.splice(this.props.bookId, 1);
        for(var i = 0; i < arr.length; i++){
            arr[i].bookId=i;
        }
        this.props.deleteBookL({arr: arr, totalBooklists: arr.length});
    };
    chBookTitle=e=>{
        this.props.chBookTitle(this.state.data.booklist_title);
        const {booklist_title} = this.state.data;
        this.setState({old_booklist_title: booklist_title})
    };
    chBookDescription=e=>{
        this.props.chBookDescription(this.state.data.booklist_description);
        const {booklist_description} = this.state.data;
        this.setState({old_booklist_description: booklist_description})
    };
    chTotalChapters=e=>{
        this.props.chTotalChapters(this.state.data.total_chapters);
        const {total_chapters} = this.state.data;
        this.setState({old_total_chapters: total_chapters})
    };
    onchange = event => this.setState({
        data: {...this.state.data, [event.target.name] : event.target.value }
    });
    render(){
        const {old_booklist_title, old_booklist_description} = this.state;
        const {booklist_title, booklist_description} = this.state.data;
        const {onchange, onsubmit, chBookTitle, chBookDescription} = this;
        return(
            <div className="form_comn">
                <form onSubmit={onsubmit}>
                    <div>
                        <label htmlFor="booklist_title">Booklist Title: </label>
                        <input 
                           type="text" 
                           className="form-control"
                           value={booklist_title}
                           name="booklist_title"
                           id="booklist_title"
                           onChange={onchange}
                           autoComplete="off"
                        /><br/>
                        {booklist_title !== old_booklist_title && (
                            <Button variant="success" onClick={chBookTitle}>Change Booklist Title</Button>
                        )}
                    </div>
                    <div>
                        <label htmlFor="booklist_description">Booklist Description: </label>
                        <textarea
                           className="form-control"
                           value={booklist_description}
                           name="booklist_description"
                           id="booklist_description"
                           onChange={onchange}
                           autoComplete="off"
                        /><br/>
                        {booklist_description !== old_booklist_description && (
                            <Button variant="success" onClick={chBookDescription}>Change Booklist Description</Button>
                        )}<br/>
                        <button className="btn btn-danger delteBookBtnEditBookList" onClick={this.deleteBook}>Delete Booklist</button>
                    </div>
                </form>
            </div>
        );
    };
};
function mapStateToProps(state){
    return {
        AllbookLists: state.AllBooklists.bookLists
    }
}

export default connect(mapStateToProps, {})(EditBookLMetaData);